var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","dark":"","color":"primary"}},[_c('v-spacer'),_c('div',{staticClass:"mr-2"},[_vm._v("© shangyuan.tuolang")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }